/** firmament (en) */
const data = {
    "intro": {
        "title": "Firmament",
        "text": "Firmament is a data watchface whose horizon is a live sky. Sun, moon and planets travel the same arc between rise and set. The ISS appears only during a pass. In season, named meteor showers streak the arc. On supported color watches you also get a star field and aurora.",
        "data": "Around the time you still have the usual configurable fields, weather, themes and — on many devices — forecast charts and an analog overlay. Sky features use your GPS location and a weather update from the phone. The watch does not poll the sky continuously."
    },
    "devices": {
        "title": "What each watch shows",
        "color": "Watches with Connect IQ 4.2 or later (AMOLED and newer MIP watches): the full sky with planets, ISS, meteors, stars and aurora, plus weather forecast charts.",
        "instinct": "Instinct 2: planets, ISS and meteors on the arc. High-contrast MIP icons. No star field, no aurora, no forecast charts.",
        "lowmem": "Older watches such as fenix 6 Pro, Venu (1st gen), vívoactive 4 and Enduro show no aurora. Everything else follows what the model can draw."
    },
    "sky": {
        "title": "Horizon, planets and stars",
        "intro": "The curved horizon is the path of the sun. Sun, moon, planets and the ISS move along this arc while they are above the horizon. Stars are placed by hemisphere: northern stars toward the outside of the dial, southern stars toward the inside.",
        "bodies": "Sun, Moon, Mercury, Venus, Mars, Jupiter, Saturn, Uranus, Neptune. Sun and moon times are calculated on the watch. Planets, ISS and stars come from the server with the weather update.",
        "icons": "Color watches use detailed icons. Instinct uses white MIP silhouettes. Both are on the legend below (color left, Instinct right for planets).",
        "stars": "All watches except Instinct show bright catalog stars, tinted by spectral type.",
        "setting": "Setting “Night sky objects display options”: show them only after dark or also during the day (in real time). “None” hides planets and stars. ISS, meteors and aurora are still shown.",
        "alt": "Planet and star legend"
    },
    "aurora": {
        "title": "Aurora",
        "intro": "A glow on the horizon when NOAA data gives your GPS location a real chance. Not a worldwide “aurora tonight” flag. The watch checks only now and then, so it keeps both a live reading and tonight’s outlook.",
        "nowLabel": "Now",
        "now": "Live chance at your spot (next 30–90 minutes).",
        "tonightLabel": "Tonight",
        "tonight": "A valid live reading (Now) always takes priority over tonight’s forecast, whether it is higher or lower.",
        "midlat": "Far from the Arctic, only a real storm reaches you. Dark, clear skies and a view to the north help. Not a guarantee — clouds, moonlight and city light can hide even a strong display.",
        "day": "The glow only appears when the sun is more than 10° below the horizon. Color watches show a soft green band; the highest level adds magenta. Instinct 2 has no aurora overlay.",
        "levelsTitle": "Four activity levels:",
        "weak": {
            "name": "Weak",
            "text": "Faint green band."
        },
        "mod": {
            "name": "Moderate",
            "text": "Brighter green curtains."
        },
        "strong": {
            "name": "Strong",
            "text": "Tall, bright rays."
        },
        "ext": {
            "name": "Extreme",
            "text": "Green with magenta."
        },
        "alt": "Aurora levels and forecast"
    },
    "meteors": {
        "title": "Meteor showers",
        "intro": "In season, meteors streak along the same horizon. Activity follows the shower window: a few streaks at the edges, more near the peak. The list below is the set Firmament actually draws — not every minor shower.",
        "cosmetic": "Between showers a single stray meteor may appear at night. That one is only cosmetic — it is not a real event at your location.",
        "listTitle": "Showers displayed on the watchface:",
        "colName": "Shower",
        "colWhen": "Peak",
        "when": {
            "0": "early Jan",
            "1": "late Apr",
            "2": "early May",
            "3": "late Jul",
            "4": "mid Aug",
            "5": "late Oct",
            "6": "mid Nov",
            "7": "mid Dec",
            "8": "late Dec"
        }
    },
    "iss": {
        "title": "ISS",
        "pass": "Shown only during a visible pass over your location. It moves along the horizon for that pass, then disappears.",
        "icons": "Color watches use the detailed station icon. Instinct draws a compact white silhouette (left on the picture).",
        "alt": "Meteors and ISS"
    },
    "data": {
        "title": "Data fields, weather and look",
        "fields": "Configurable fields around the time: top rows, left and right of the clock and icon slots. Four more fields under the arc appear when a switchview is set to “Dataset 1 Bottom”. Not every option exists on every watch.",
        "switch": "Switchviews change the view under the arc. Switch by raising the wrist a second time within 7 seconds or, on touch watches, by a long press on the hour or minute.",
        "weather": "Pick a weather provider in settings. Current conditions and (on color o420-class) forecast charts update when the watch talks to the phone — typically every few minutes, not live.",
        "look": "Themes, time and data fonts, colors, and on many devices an analog overlay and always-on display options are in the watchface settings. Theme strings work like on our other faces."
    },
    "need": {
        "title": "What you need",
        "location": "Location on, and at least one successful weather update. Without that, rise/set, ISS, aurora and showers stay empty.",
        "gps": "If times look wrong, do a GPS fix (start an activity until the watch has a lock, or use the GPS button), then return to the watchface and wait for the next update.",
        "dark": "Aurora appears only in darkness. The occasional single meteor only shows at night, while shower meteors are drawn for the whole shower window. Outdoors you still need dark, clear skies to see the real sky."
    }
};
export default data;
